module.exports = __webpack_public_path__ + "media/images/menu/ursa_minor-3b62e529db36ece8c0e6fcd85ddf38d7.jpg";